import './categories.scss';
import React, {useEffect, useState} from "react";
import {categoriesMapping, getCategoryById} from "./categories_mapping.js";
import {useStateContext} from "../../helpers/state-context.js";
import {CategoryItem} from "./item.js";
import {Analytics} from '../../helpers/analytics/index.js';

function Categories() {
    const [mobileTitle, updateMobileTitle] = useState(false);
    const [state, dispatch] = useStateContext(['categories', 'renderSize', 'selectedCategory', 'county']);
    const viewSize = (state.renderSize === 'xs') ? 'xsmall' : (state.renderSize === 'sm') ? 'small' : 'full';

    // Hide mobile title after 2 seconds
    useEffect(() => {
        let timer;
        if(viewSize === 'xsmall'){
            timer = setTimeout(() => {
                updateMobileTitle(false)
            }, 2000);
        }
        return () => clearTimeout(timer);
    }, [state.categories, viewSize])

    return <div className={'overlay'}>
        <h2 style={{
            color: '#283583',
            zIndex: 10,
            position: 'relative',
            margin: '0px',
            padding: (viewSize === 'xsmall') ? '5px 0px': '5px 0px 10px 0px',
            background: 'linear-gradient(180deg, rgba(255,255,255,0.8) 50%, rgba(255,255,255,0) 100%)',
            fontSize: (viewSize === 'xsmall') ? 18: 26}}
        >
            World map of mobile spouse and partner work authorisation
        </h2>
        <div className={'category-container'}>
            {categoriesMapping.map(category => {
                const isCategoryActive = state.categories && state.categories.includes(category.id);

                const categoryStyle = {opacity: (isCategoryActive) ? `1` : `.5`, zIndex: 10};
                const iconStyle = {
                    border: (isCategoryActive) ?
                            `${(viewSize === 'xsmall') ? '2px' :'4px'} solid ${category.color}` :
                            `${(viewSize === 'xsmall') ? '2px' :'4px'} solid #fff`,
                    width: (viewSize === 'xsmall') ? 40 : (viewSize === 'small') ? 50 : 70,
                    height: (viewSize === 'xsmall') ? 40 : (viewSize === 'small') ? 50 : 70,
                    margin: (viewSize === 'xsmall') ? '5px' : '0 15px',
                };
                return <CategoryItem key={category.id}
                        category={category}
                        viewSize={viewSize}
                        textColor={'#000'}
                        isCategoryActive={isCategoryActive}
                        onClick={(category) => {
                            if (state.selectedCategory === category.id) {
                                dispatch({type: 'selectedCategory', value: null});
                                dispatch({type: 'setDefaultCategories'})
                            } else {
                                dispatch({type: 'selectedCategory', value: category.id});
                                dispatch({type: 'categories', value: [category.id]});
                                Analytics.trackEvent({
                                    action: 'select category',
                                    category: 'category icons',
                                    label: category.description
                                });
                            }
                        }}
                        onMouseEnter={(category) => {
                            if(state.country){
                                dispatch({type: 'country', value: null});
                            }
                            dispatch({type: 'categories', value: [category.id]});
                            updateMobileTitle(true);
                        }}
                        onMouseLeave={() => {
                            if (state.selectedCategory) {
                                dispatch({type: 'categories', value: [state.selectedCategory]});
                            } else {
                                dispatch({type: 'setDefaultCategories'})
                            }
                        }}
                        categoryStyle={categoryStyle}
                        iconStyle={iconStyle}/>
            })}

        </div>
        {(['xsmall', 'small'].includes(viewSize)  && mobileTitle) &&
                <div className={'mobile-category-title'}>
                    {state.categories.map(categoryId => {
                        const category = getCategoryById(categoryId)
                        return <span key={categoryId} style={{color: category.color}}>
                            {category.description}
                        </span>
                    })}
                </div>
        }
    </div>
}

Categories.defaultProps = {};

export {Categories}